import React from 'preact/compat';
import { Field } from 'formik';
import FormError from '../error';
import FormLabel from '../label';

export default function MessageFields() {
    return (
        <div className='form__section'>
            <div className='form__header'>
                <h2 className='form__heading'>Contact details</h2>
            </div>
            <div className='form__grid'>
                <div className='form__grid-item  form__grid-item--title  form__field'>
                    <FormLabel htmlFor='title' required={true}>Title</FormLabel>
                    <Field as='select' name='title' id='title' className='input  input--select'>
                        <option />
                        <option>Mr</option>
                        <option>Mrs</option>
                        <option>Miss</option>
                        <option>Ms</option>
                        <option>Other</option>
                    </Field>
                    <FormError name='title' />
                </div>
                <div className='form__grid-item  form__grid-item--name  form__field'>
                    <FormLabel htmlFor='firstName' required={true}>First name</FormLabel>
                    <Field name='firstName' id='firstName' className='input' />
                    <FormError name='firstName' />
                </div>
                <div className='form__grid-item  form__grid-item--name  form__field'>
                    <FormLabel htmlFor='lastName' required={true}>Last name</FormLabel>
                    <Field name='lastName' id='lastName' className='input' />
                    <FormError name='lastName' />
                </div>
                <div className='form__grid-item  form__grid-item--wide  form__field'>
                    <FormLabel htmlFor='email' required={true}>Email address</FormLabel>
                    <Field type='email' name='email' id='email' className='input' />
                    <FormError name='email' />
                </div>
                <div className='form__grid-item  form__grid-item--wide  form__field'>
                    <FormLabel htmlFor='message' required={true}>Message</FormLabel>
                    <Field as='textarea' name='message' id='message' className='input  input--textarea' />
                    <FormError name='message' />
                </div>
            </div>
        </div>
    );
}
